const RequiredDocuments = ({ documents, language = false }) => {
  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {documents.map((doc, idx) => (
          <div
            key={idx}
            className="border border-gray-300 rounded-lg p-4 shadow-sm flex items-center space-x-3"
          >
            <span className="text-[#018f9b] text-xl">{doc.icon}</span>
            <span>{language ? doc.text.hi : doc.text.en}</span>
          </div>
        ))}
      </div>
    </>
  );
};

export default RequiredDocuments;
